.tooltip-icon {
  width: 16px;
  color: var(--default--icon-button--fill-color--1);
}

.duty-label {
  margin-right: var(--space-16);
}

.tooltip-wrapper {
  position: relative;
  top: 2px;
}
